import { handleRedirectMiddleware, checkEarlyRedirect } from '@nuxt-monorepo/ui/utils/seo';
import { stringifyQuery, type RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (import.meta.client) return;

    if (useRequestURL().hostname === 'shuttlefinder.com') {
        navigateTo('https://www.shuttlefinder.com' + to.path + (to.query ? '?' + stringifyQuery(to.query) : ''), {
            external: true,
            redirectCode: 302,
        });
    }

    const {
        public: { STORYBLOK_FOLDER, STORYBLOK_VERSION, STORYBLOK_TOKEN },
    } = useRuntimeConfig();

    const result = await handleRedirectMiddleware(to, from, checkEarlyRedirect, {
        folder: STORYBLOK_FOLDER,
        version: STORYBLOK_VERSION,
        token: STORYBLOK_TOKEN,
    });

    if (result?.type === 'redirect') {
        return navigateTo(result.target, {
            external: true,
            redirectCode: result.statusCode ?? 302,
        });
    }
});
